import { Routes } from '@angular/router';
import { ReadingMatrixCategorisePage } from './reading-matrix-categorise-page/reading-matrix-categorise-page';
import { ReadingMatrixNoTimePage } from './reading-matrix-no-time-page/reading-matrix-no-time-page';
import { ReadingMatrixPage } from './reading-matrix-page';
import { ReadingMatrixStopwatchPage } from './reading-matrix-stopwatch-page/reading-matrix-stopwatch-page';
import { ReadingMatrixTimerPage } from './reading-matrix-timer-page/reading-matrix-timer-page';

export const mechanicReadingMatrixRoutes: Routes = [
  {
    path: '',
    component: ReadingMatrixPage,
  },
  {
    path: 'no-time',
    component: ReadingMatrixNoTimePage,
  },
  {
    path: 'timer',
    component: ReadingMatrixTimerPage,
  },
  {
    path: 'stopwatch',
    component: ReadingMatrixStopwatchPage,
  },
  {
    path: 'categorise',
    component: ReadingMatrixCategorisePage,
  },
];
